import { Link } from "react-router-dom";

export default function DisclaimerPage() {
  return (
    <div>
      {/* Hero Section */}
      <section className="py-16 bg-slate-900">
        <div className="container-custom">
          <h1 className="heading-primary text-white mb-4" data-testid="disclaimer-title">
            Disclaimer
          </h1>
          <p className="text-slate-400">Last updated: January 2024</p>
        </div>
      </section>

      {/* Content */}
      <section className="section-padding bg-white" data-testid="disclaimer-content">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto prose prose-slate prose-lg">
            <h2 className="heading-tertiary text-slate-900">Website Disclaimer</h2>
            <p className="text-slate-600 mb-8">
              The information provided by BuyVistas ("we," "us," or "our") on our website is for 
              general informational purposes only. All information on the site is provided in good 
              faith; however, we make no representation or warranty of any kind, express or implied, 
              regarding the accuracy, adequacy, validity, reliability, availability, or completeness 
              of any information on the site.
            </p>

            <h2 className="heading-tertiary text-slate-900">External Links Disclaimer</h2>
            <p className="text-slate-600 mb-8">
              Our website may contain links to other websites or content belonging to or originating 
              from third parties. Such external links are not investigated, monitored, or checked for 
              accuracy, adequacy, validity, reliability, availability, or completeness by us. We do 
              not warrant, endorse, guarantee, or assume responsibility for the accuracy or reliability 
              of any information offered by third-party websites linked through our site.
            </p>

            <h2 className="heading-tertiary text-slate-900">Professional Disclaimer</h2>
            <p className="text-slate-600 mb-8">
              The site cannot and does not contain professional advice specific to your situation. 
              The information is provided for general informational and educational purposes only and 
              is not a substitute for professional advice. Accordingly, before taking any actions based 
              upon such information, we encourage you to consult with the appropriate professionals.
            </p>

            <h2 className="heading-tertiary text-slate-900">Service Results Disclaimer</h2>
            <p className="text-slate-600 mb-8">
              While we strive to provide the highest quality pressure washing services, results may 
              vary depending on the condition, age, and material of the surfaces being cleaned. 
              Before-and-after photos on our website represent typical results, but individual 
              results may differ. Some stains, discolorations, or damage may be permanent and 
              cannot be removed through pressure washing.
            </p>

            <h2 className="heading-tertiary text-slate-900">Testimonials Disclaimer</h2>
            <p className="text-slate-600 mb-8">
              The testimonials on our website are from actual customers and reflect their individual 
              experiences with our services. These testimonials are not intended to guarantee that 
              everyone will achieve the same or similar results. Individual results may vary.
            </p>

            <h2 className="heading-tertiary text-slate-900">Errors and Omissions Disclaimer</h2>
            <p className="text-slate-600 mb-8">
              While we have made every attempt to ensure that the information contained on this 
              website is accurate, we are not responsible for any errors or omissions, or for the 
              results obtained from the use of this information. All information is provided "as is," 
              with no guarantee of completeness, accuracy, timeliness, or of the results obtained 
              from the use of this information.
            </p>

            <h2 className="heading-tertiary text-slate-900">Fair Use Disclaimer</h2>
            <p className="text-slate-600 mb-8">
              This website may contain copyrighted material, the use of which has not always been 
              specifically authorized by the copyright owner. We believe this constitutes "fair use" 
              of any such copyrighted material as provided for in section 107 of the US Copyright Law.
            </p>

            <h2 className="heading-tertiary text-slate-900">Views Expressed Disclaimer</h2>
            <p className="text-slate-600 mb-8">
              Any views or opinions represented on this website belong solely to the content creators 
              and do not represent those of people, institutions, or organizations that BuyVistas or 
              creators may or may not be associated with in professional or personal capacity, unless 
              explicitly stated.
            </p>

            <h2 className="heading-tertiary text-slate-900">No Responsibility Disclaimer</h2>
            <p className="text-slate-600 mb-8">
              Under no circumstances shall we have any liability to you for any loss or damage of 
              any kind incurred as a result of the use of our website or reliance on any information 
              provided on the website. Your use of the website and your reliance on any information 
              on the website is solely at your own risk.
            </p>

            <h2 className="heading-tertiary text-slate-900">Contact Us</h2>
            <p className="text-slate-600 mb-4">
              If you have any questions about this Disclaimer, please contact us:
            </p>
            <ul className="list-none text-slate-600 mb-8">
              <li><strong>Email:</strong> support@buyvistas.store</li>
              <li><strong>Phone:</strong> +1-888-435-4674</li>
              <li><strong>Address:</strong> 20 E 22nd St #4699, New York, NY 10165</li>
            </ul>

            <div className="mt-12 pt-8 border-t border-slate-200">
              <Link to="/" className="text-sky-600 hover:text-sky-700 font-semibold">
                ← Back to Home
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
